import { useKeycloakContext } from "./KeycloakProvider";

export function useAuth() {
  const ctx = useKeycloakContext();
  return {
    initialized: ctx.initialized,
    isAuthenticated: ctx.authenticated,
    user: ctx.user,
    initError: ctx.initError,
    login: ctx.login,
    logout: ctx.logout,
  };
}
